module.exports = __webpack_public_path__ + "22b42065830766e863ee8c117b240c80.svg";